import React from "react";
import { Link } from "react-router-dom";
import singleClick from "../../images/hireDeveloper/singleClick.jpg";

const SingleClick = () => {
  return (
    <>
      <section
        className="singleClickSection"
        style={{ backgroundImage: `url(${singleClick})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="details" data-aos="zoom-in">
                <h3>
                  You're Just A <span>Single Click Away</span> To Get Your Dream
                  Remote Job
                </h3>
                <Link to="/GetHireDeveloper" className="btn">
                  <span>Apply For Remote Jobs</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SingleClick;
